"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activeProductLegacyOrganizationEnterprise = exports.activeProductLegacyUserEducational = exports.stripeProductTrialUltra = exports.stripeProductLegacyOrganizationPaid = exports.stripeProductLegacyUserEarly = exports.stripeProductLegacyUserPro = exports.stripeProductLegacyUserUltra = void 0;
const models_1 = require("@buildwithflux/models");
/*
 * These Stripe product UIDs relate to legacy plan subscriptions, and are only in use until we can better
 * backfill the Stripe metadata and/or price lookup keys, at which point we should use them by preference.
 */
exports.stripeProductLegacyUserUltra = models_1.PaymentPlanUids.userLegacyUltra;
exports.stripeProductLegacyUserPro = models_1.PaymentPlanUids.userLegacyPro;
exports.stripeProductLegacyUserEarly = models_1.PaymentPlanUids.userLegacyEarly;
exports.stripeProductLegacyOrganizationPaid = models_1.PaymentPlanUids.organizationPaid;
/**
 * This is the product ID of the time-limited trial subscription we want to create for new users
 */
exports.stripeProductTrialUltra = "prod_QpTrJOzoHgI5YX";
/*
 * There are other values that aren't "true" Stripe product UIDs and are instead special values we'd put
 * in the activeProductUid of the account.
 */
exports.activeProductLegacyUserEducational = models_1.PaymentPlanUids.userLegacyEdu;
exports.activeProductLegacyOrganizationEnterprise = models_1.PaymentPlanUids.organizationEnterprise;
//# sourceMappingURL=stripe.js.map